function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @kaokei/di
 * Tiny di library depends on typescript and reflect-metadata
 *
 * @version 2.0.9
 * @author kaokei
 * @license MIT
 * @link https://github.com/kaokei/di
 */

var DECORATOR_KEYS = {
  // ts自带的类的实例属性的类型的key
  DESIGN_PROPERTY_TYPE: 'design:type',
  // ts自带的类的构造函数的参数的类型信息的key
  DESIGN_PARAM_TYPES: 'design:paramtypes',
  // 记录构造函数参数装饰器对应的数据的key
  SERVICE_INJECTED_PARAMS: 'service:injected:params',
  // 记录实例属性装饰器对应的数据的key
  SERVICE_INJECTED_PROPS: 'service:injected:props',
  // Inject装饰器的key
  INJECT: Symbol('inject'),
  // Injectable装饰器的key
  INJECTABLE: Symbol('injectable'),
  // Self装饰器的key
  SELF: 'self',
  // Skip装饰器的key
  SKIP_SELF: 'skip',
  // Optional装饰器的key
  OPTIONAL: 'optional'
};
var SERVICE_STATUS = {
  INITING: Symbol('initing'),
  CONSTRUCTED: Symbol('constructed'),
  MERGED: Symbol('merged')
};
var CircularDependencyError = /*#__PURE__*/function (_Error) {
  _inherits(CircularDependencyError, _Error);
  var _super = _createSuper(CircularDependencyError);
  function CircularDependencyError(provider, options) {
    var _this;
    _classCallCheck(this, CircularDependencyError);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "name", 'CIRCULAR_DEPENDENCY_ERROR');
    _defineProperty(_assertThisInitialized(_this), "message", _this.name);
    var tokenArr = [provider.provide];
    var currentProvider = options === null || options === void 0 ? void 0 : options.provider;
    while (currentProvider && currentProvider.provide) {
      tokenArr.push(currentProvider.provide);
      currentProvider = currentProvider.parent;
    }
    var tokenListText = tokenArr.join(' <-- ');
    _this.message = "CIRCULAR DEPENDENCY DETECTED. PLEASE FIX IT MANUALLY. \n ".concat(tokenListText);
    return _this;
  }
  return _createClass(CircularDependencyError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var InjectFailedError = /*#__PURE__*/function (_Error2) {
  _inherits(InjectFailedError, _Error2);
  var _super2 = _createSuper(InjectFailedError);
  function InjectFailedError(injectMeta, ClassName, key, paramType) {
    var _this2;
    _classCallCheck(this, InjectFailedError);
    _this2 = _super2.call(this);
    _defineProperty(_assertThisInitialized(_this2), "name", 'INJECT_FAILED_ERROR');
    _defineProperty(_assertThisInitialized(_this2), "message", _this2.name);
    if (paramType) {
      // 是构造函数的参数装饰器
      if (injectMeta && injectMeta.value === Object) {
        _this2.message = "CAN NOT USE OBJECT AS INJECTION TOKEN. PARAMETER ".concat(key, " OF CLASS ").concat(ClassName, ".");
      } else if (paramType === Object) {
        _this2.message = "CONSTRUCTOR PARAMETER TYPE IS OBJECT OR INTERFACE, MUST USE @INJECT TO SPECIFY INJECTION TOKEN. PARAMETER ".concat(key, " OF CLASS ").concat(ClassName, ".");
      }
    } else {
      // 是属性装饰器
      if (!injectMeta) {
        _this2.message = "INJECT PROPERTY REQUIRE @INJECT() DECORATOR. PROPERTY ".concat(key, " OF CLASS ").concat(ClassName, ".");
      } else if (injectMeta.value === Object) {
        _this2.message = "CAN NOT USE OBJECT AS INJECTION TOKEN. PROPERTY ".concat(key, " OF CLASS ").concat(ClassName, ".");
      }
    }
    return _this2;
  }
  return _createClass(InjectFailedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var ProviderNotValidError = /*#__PURE__*/function (_Error3) {
  _inherits(ProviderNotValidError, _Error3);
  var _super3 = _createSuper(ProviderNotValidError);
  function ProviderNotValidError(provider) {
    var _this3;
    _classCallCheck(this, ProviderNotValidError);
    _this3 = _super3.call(this);
    _defineProperty(_assertThisInitialized(_this3), "name", 'PROVIDER_NOT_VALID_ERROR');
    _defineProperty(_assertThisInitialized(_this3), "message", _this3.name);
    _this3.message = "PROVIDER NOT VALID. ".concat(provider);
    return _this3;
  }
  return _createClass(ProviderNotValidError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var TokenNotFoundError = /*#__PURE__*/function (_Error4) {
  _inherits(TokenNotFoundError, _Error4);
  var _super4 = _createSuper(TokenNotFoundError);
  function TokenNotFoundError(token) {
    var _this4;
    _classCallCheck(this, TokenNotFoundError);
    _this4 = _super4.call(this);
    _defineProperty(_assertThisInitialized(_this4), "name", 'TOKEN_NOT_FOUND_ERROR');
    _defineProperty(_assertThisInitialized(_this4), "message", _this4.name);
    _this4.message = "TOKEN IS NOT A INJECTABLE CLASS OR SKIP OUT OF ROOT INJECTOR. YOU CAN USE @Optional DECORATOR TO IGNORE THIS ERROR IF THIS SERVICE IS OPTIONAL. ".concat(token);
    return _this4;
  }
  return _createClass(TokenNotFoundError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var ConstructorInjectMissTokenError = /*#__PURE__*/function (_Error5) {
  _inherits(ConstructorInjectMissTokenError, _Error5);
  var _super5 = _createSuper(ConstructorInjectMissTokenError);
  function ConstructorInjectMissTokenError(target) {
    var _this5;
    _classCallCheck(this, ConstructorInjectMissTokenError);
    _this5 = _super5.call(this);
    _defineProperty(_assertThisInitialized(_this5), "name", 'CONSTRUCTOR_INJECT_MISS_TOKEN_ERROR');
    _defineProperty(_assertThisInitialized(_this5), "message", _this5.name);
    _this5.message = "For the constructor of class ".concat(target, ", every parameter must specify a @Inject.");
    return _this5;
  }
  return _createClass(ConstructorInjectMissTokenError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var PropertyInjectMissTokenError = /*#__PURE__*/function (_Error6) {
  _inherits(PropertyInjectMissTokenError, _Error6);
  var _super6 = _createSuper(PropertyInjectMissTokenError);
  function PropertyInjectMissTokenError(target, targetKey) {
    var _this6;
    _classCallCheck(this, PropertyInjectMissTokenError);
    _this6 = _super6.call(this);
    _defineProperty(_assertThisInitialized(_this6), "name", 'PROPERTY_INJECT_MISS_TOKEN_ERROR');
    _defineProperty(_assertThisInitialized(_this6), "message", _this6.name);
    _this6.message = "For the property ".concat(targetKey, " of class ").concat(target, ", @Inject must specify a token.");
    return _this6;
  }
  return _createClass(PropertyInjectMissTokenError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * 这里记录不同的装饰器的参数的含义
 *
 * class decorator:
 *   只有一个参数：构造函数
 * property decorator:
 *   静态属性：构造函数, 属性名
 *   实例属性：原型, 属性名
 * parameter decorator:
 *   构造函数参数：构造函数, undefined, 0
 *   普通函数参数：原型, 方法名, 0
 *   静态函数参数：构造函数, 方法名, 0
 * method decorator:
 *   静态方法：构造函数, 方法名, 属性描述符
 *   实例方法：原型, 方法名, 属性描述符
 * accessor decorator:
 *   静态访问器：构造函数, 方法名, 属性描述符
 *   实例访问器：原型, 方法名, 属性描述符
 */
/**
 * 创建装饰器的高阶函数
 * 装饰器的通用逻辑就是通过Reflect记录到全局的Map中
 * 所以可以抽象出一个通用逻辑，这里需要注意对Inject装饰器有特殊判断
 *
 * @param {(string | symbol)} decoratorKey 代表某个装饰器的名称
 * @param {*} [defaultValue] 该装饰器函数的默认参数
 * @return {*} 一个装饰器
 */
function createDecorator(decoratorKey, defaultValue) {
  // 因为装饰器本身作为一个函数是有参数的，此处的decoratorValue就是实际使用装饰器的实参
  return function (decoratorValue) {
    // 目前的装饰器只支持类的构造函数参数装饰器和类的实例属性装饰器
    // target可能是构造函数或者类的原型
    // 如果target是构造函数，targetKey是undefined，index是参数的位置下标
    // 如果target是原型，targetKey是属姓名，index是undefined
    return function (target, targetKey, index) {
      // 如果index是number，那么代表是构造函数的参数的装饰器
      var isParameterDecorator = typeof index === 'number';
      // 统一把装饰器数据绑定到构造函数上，后续获取数据比较方便
      var Ctor = isParameterDecorator ? target : target.constructor;
      // 如果是构造函数的参数装饰器，取参数位置下标，否则取实例属性的属性名
      var key = isParameterDecorator ? index : targetKey;
      // 区分构造函数的参数装饰器和实例属性的装饰器
      // 分别记录到全局Map的不同位置，metadataKey不一样
      var metadataKey = isParameterDecorator ? DECORATOR_KEYS.SERVICE_INJECTED_PARAMS : DECORATOR_KEYS.SERVICE_INJECTED_PROPS;
      // 这里是一个大对象，对应的key是metadataKey
      // 所以全局Map中有两个不同的metadataKey，以及对应的数据对象
      // 如果是构造函数参数装饰器，这个对象中的key是参数位置下标
      // 如果是实例属性装饰器，这个对象中的key是属性名
      // 这里有一个坑，必须使用getOwnMetadata而不是getMetadata
      // 否则在继承的场景中会有问题
      var paramsOrPropertiesMetadata = Reflect.getOwnMetadata(metadataKey, Ctor) || {};
      // 每个参数或者实例属性都可以有多个装饰器
      // 所以paramsOrPropertiesMetadata这个大对象的每个key(实例属性)对应的value都是一个数组
      // 该数组中的每一个元素是一个对象，保存着每一个装饰器的数据
      var paramOrPropertyMetadata = paramsOrPropertiesMetadata[key] || [];
      var metadata = {
        // 装饰器的名称
        key: decoratorKey,
        // 装饰器的值，即装饰器函数的实参
        // 很多装饰器具有默认值，可以不提供实参，而是使用默认值
        value: decoratorValue === void 0 ? defaultValue : decoratorValue
      };
      // 当项目使用esbuild不支持emitDecoratorMetadata时
      // 这里检查了@Inject装饰器在实例属性中需要指定参数
      // 如果是构造函数理论上也需要使用@inject装饰器，并且需要指定参数
      // 只不过没有在这里做判断，而是在getContructorParametersMetas中判断的
      if (!isParameterDecorator) {
        // 实例属性装饰器
        if (decoratorKey === DECORATOR_KEYS.INJECT) {
          // 是@Inject装饰器
          if (decoratorValue === void 0) {
            // 装饰器没有指定参数
            // 所以需要通过Reflect获取默认的类型数据
            var metadataValue = Reflect.getMetadata(DECORATOR_KEYS.DESIGN_PROPERTY_TYPE, target, targetKey);
            {
              if (metadataValue === void 0) {
                throw new PropertyInjectMissTokenError(target, targetKey);
              }
            }
            metadata.value = metadataValue;
          }
        }
      }
      // 把当前装饰器的数据对象放到数组中
      paramOrPropertyMetadata.push(metadata);
      // 关联这个数组和对应的key
      paramsOrPropertiesMetadata[key] = paramOrPropertyMetadata;
      // 再把整个大对象放到全局Map中
      Reflect.defineMetadata(metadataKey, paramsOrPropertiesMetadata, Ctor);
    };
  };
}
// 可以使用在类构造函数的参数中和类的实例属性中
var Inject = createDecorator(DECORATOR_KEYS.INJECT);
// 指定只在当前injector中寻找服务
var Self = createDecorator(DECORATOR_KEYS.SELF, true);
// 指定跳过当前injector寻找服务
var Skip = createDecorator(DECORATOR_KEYS.SKIP_SELF, true);
// 指定服务是可选的，找不到服务时返回undefined，否则抛出异常
// 其实应该说是默认情况下找不到服务时，会抛出异常，除非明确指定是optional的
var Optional = createDecorator(DECORATOR_KEYS.OPTIONAL, true);
/**
 * 表明服务可注入
 * 主要工作就是收集构造函数的参数类型信息
 *
 * @export
 * @return {*}
 */
function Injectable() {
  return function (target) {
    // 标记这个类可以注入
    Reflect.defineMetadata(DECORATOR_KEYS.INJECTABLE, true, target);
    return target;
  };
}
function has(obj, key) {
  return obj && Object.prototype.hasOwnProperty.call(obj, key);
}
function merge(target, source) {
  for (var key in source) {
    if (has(source, key)) {
      target[key] = source[key];
    }
  }
  return target;
}
function isInjectableToken(token) {
  return typeof token === 'function' && Reflect.getMetadata(DECORATOR_KEYS.INJECTABLE, token);
}
function forwardRef(fn) {
  fn.__forward_ref__ = forwardRef;
  return fn;
}
function isForwardRef(fn) {
  return typeof fn === 'function' && has(fn, '__forward_ref__') && fn.__forward_ref__ === forwardRef;
}
function resolveForwardRef(type) {
  return isForwardRef(type) ? type() : type;
}
var NOOP = function NOOP(n) {
  return n;
};
// 第一步：准备构造函数的依赖对象
// 第二步：通过构造函数来获取服务的实例对象
// 第三步：补充@Inject注入的实例属性
// 第四步：执行constructed方法
var Injector = /*#__PURE__*/function () {
  function Injector() {
    var providers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var parent = arguments.length > 1 ? arguments[1] : undefined;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, Injector);
    _defineProperty(this, "parent", void 0);
    _defineProperty(this, "providerMap", new Map());
    // <token, provider>
    _defineProperty(this, "beforeCacheHook", void 0);
    _defineProperty(this, "mergePropertyHook", void 0);
    // 引用父级Injector
    this.parent = parent;
    // 在把服务实例放到缓存中之前，可以调用这个钩子让服务响应化
    this.beforeCacheHook = options.beforeCacheHook || NOOP;
    // 在注入实例属性时，需要把属性merge到服务实例对象上，合并过程需要保持响应式
    this.mergePropertyHook = options.mergePropertyHook || merge;
    this.addProviders(providers);
  }
  /**
   * 如果没有parent则是root injector
   */
  _createClass(Injector, [{
    key: "isRootInjector",
    value: function isRootInjector() {
      return !this.parent;
    }
    /**
     * 如果没有指定当前token是可选的，则抛出异常
     * @param token
     * @param options
     */
  }, {
    key: "checkTokenNotFoundError",
    value: function checkTokenNotFoundError(token, options) {
      if (!options.optional) {
        throw new TokenNotFoundError(token);
      }
    }
  }, {
    key: "get",
    value: function get(token) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (options.skip) {
        // 优先判断skip，是因为可以实现三种不同的组合
        // 1. 只有skip
        // 1. 只有self
        // 1. 同时有skip和self
        if (this.parent) {
          // 最多只能跳过一次，虽然也可以将skip设为number类型，从而可以控制跳过的次数，但是没有必要
          return this.parent.get(token, _objectSpread(_objectSpread({}, options), {}, {
            skip: false
          }));
        } else {
          this.checkTokenNotFoundError(token, options);
        }
      } else if (options.self) {
        if (this.providerMap.has(token)) {
          var provider = this.providerMap.get(token);
          return this.getServiceByProvider(provider, options);
        } else if (this.isRootInjector() && isInjectableToken(token)) {
          // 这里的场景是 useRootService(Token, {self: true})
          // 应该不会有人这样写代码，这里只是为了代码逻辑的完整性
          // 正常业务代码只需要写 useRootService(Token) 即可
          var _provider = this.getProviderByToken(token);
          return this.getServiceByProvider(_provider, options);
        } else {
          this.checkTokenNotFoundError(token, options);
        }
      } else if (this.providerMap.has(token)) {
        var _provider2 = this.providerMap.get(token);
        return this.getServiceByProvider(_provider2, options);
      } else if (this.parent) {
        return this.parent.get(token, options);
      } else if (isInjectableToken(token)) {
        // 这里代表是root injector
        // 这里的意思代表所有Injectable Class都可以自动在root injector中实例化
        // 不再需要手动调用declareRootProviders这个方法
        // 当然declareRootProviders这个方法有其他使用场景，比如不是以Class作为token
        var _provider3 = this.getProviderByToken(token);
        return this.getServiceByProvider(_provider3, options);
      } else {
        this.checkTokenNotFoundError(token, options);
      }
    }
    /**
     * 如果token对应的provider不存在
     * 那么就创建一个
     * 目前来看这个方法只是针对root injector使用，属于兜底策略
     * 调用该方法之前需要保证token对应的provider已经存在或者token本身是一个可注入的类
     *
     * @param {*} token
     * @return {*}
     * @memberof Injector
     */
  }, {
    key: "getProviderByToken",
    value: function getProviderByToken(token) {
      if (!this.providerMap.has(token)) {
        this.addProvider(token);
      }
      return this.providerMap.get(token);
    }
    /**
     * 通过provider直接获取service实例
     *
     * @param {*} provider
     * @param {*} options
     * @return {*}
     * @memberof Injector
     */
  }, {
    key: "getServiceByProvider",
    value: function getServiceByProvider(provider, options) {
      if (provider.status === SERVICE_STATUS.INITING) {
        throw new CircularDependencyError(provider, options);
      }
      if ('useCacheValue' in provider) {
        return provider.useCacheValue;
      } else if ('useValue' in provider) {
        return this.getServiceUseValueWithProvider(provider);
      } else if (provider.useClass) {
        return this.getServiceUseClassWithProvider(provider, options);
      } else if (provider.useExisting) {
        return this.getServiceUseExistingWithProvider(provider, options);
      } else if (provider.useFactory) {
        return this.getServiceUseFactoryWithProvider(provider, options);
      } else {
        throw new ProviderNotValidError(provider);
      }
    }
    /**
     * 通过useValue获取服务实例
     *
     * @param {*} provider
     * @return {*}
     * @memberof Injector
     */
  }, {
    key: "getServiceUseValueWithProvider",
    value: function getServiceUseValueWithProvider(provider) {
      var cacheValue = this.beforeCacheHook(provider.useValue);
      provider.useCacheValue = cacheValue;
      return cacheValue;
    }
    /**
     * 通过useClass获取服务实例
     *
     * @param {*} provider
     * @param {*} options
     * @return {*}
     * @memberof Injector
     */
  }, {
    key: "getServiceUseClassWithProvider",
    value: function getServiceUseClassWithProvider(provider, options) {
      provider.status = SERVICE_STATUS.INITING;
      provider.parent = options.provider;
      var ClassName = provider.useClass;
      var params = this.getContructorParameters(ClassName, provider);
      var cacheValue = this.beforeCacheHook(_construct(ClassName, _toConsumableArray(params)));
      // 实例化成功，此时不会再有死循环问题
      provider.useCacheValue = cacheValue;
      provider.status = SERVICE_STATUS.CONSTRUCTED;
      var properties = this.getInjectProperties(ClassName, provider);
      this.mergePropertyHook(cacheValue, properties);
      provider.parent = void 0;
      provider.status = SERVICE_STATUS.MERGED;
      return cacheValue;
    }
    /**
     * 通过useExisting获取服务实例
     *
     * @param {*} provider
     * @param {*} options
     * @return {*}
     * @memberof Injector
     */
  }, {
    key: "getServiceUseExistingWithProvider",
    value: function getServiceUseExistingWithProvider(provider, options) {
      provider.status = SERVICE_STATUS.INITING;
      provider.parent = options.provider;
      var cacheValue = this.get(provider.useExisting, _objectSpread(_objectSpread({}, options), {}, {
        provider: provider
      }));
      provider.useCacheValue = cacheValue;
      provider.parent = void 0;
      provider.status = SERVICE_STATUS.CONSTRUCTED;
      return cacheValue;
    }
    /**
     * 通过useFactory获取服务实例
     *
     * @param {*} provider
     * @param {*} options
     * @return {*}
     * @memberof Injector
     */
  }, {
    key: "getServiceUseFactoryWithProvider",
    value: function getServiceUseFactoryWithProvider(provider, options) {
      var _this7 = this;
      provider.status = SERVICE_STATUS.INITING;
      provider.parent = options.provider;
      var deps = provider.deps || [];
      var args = deps.map(function (dep) {
        return _this7.get(dep, {
          provider: provider
        });
      });
      var serviceValue = provider.useFactory.apply(provider, _toConsumableArray(args));
      var cacheValue = this.beforeCacheHook(serviceValue);
      provider.useCacheValue = cacheValue;
      provider.parent = void 0;
      provider.status = SERVICE_STATUS.CONSTRUCTED;
      return cacheValue;
    }
    /**
     * 获取构造函数的参数-返回数组
     *
     * @param {*} ClassName
     * @param {*} provider
     * @return {*}
     * @memberof Injector
     */
  }, {
    key: "getContructorParameters",
    value: function getContructorParameters(ClassName, provider) {
      var _this8 = this;
      var params = this.getContructorParametersMetas(ClassName);
      var result = params.map(function (meta) {
        return _this8.get(meta.provide, _objectSpread(_objectSpread({}, meta.value), {}, {
          provider: provider
        }));
      });
      return result;
    }
    /**
     * 获取构造函数的参数的装饰器元数据
     *
     * @param {*} ClassName
     * @return {*}
     * @memberof Injector
     */
  }, {
    key: "getContructorParametersMetas",
    value: function getContructorParametersMetas(ClassName) {
      // 构造函数的参数的类型数据-原始数据-是一个数组
      var params = Reflect.getMetadata(DECORATOR_KEYS.DESIGN_PARAM_TYPES, ClassName);
      // 构造函数的参数的类型数据-通过@Inject等装饰器实现-是一个对象-key是数字-对应第几个参数的类型数据
      var propertiesMetadatas = Reflect.getMetadata(DECORATOR_KEYS.SERVICE_INJECTED_PARAMS, ClassName) || {};
      // 获取当前构造函数的形参个数
      var classParamsLength = ClassName.length;
      {
        if (!params) {
          // params不存在说明当前环境不支持emitDecoratorMetadata
          var propertiesMetadatasLength = Object.keys(propertiesMetadatas).length;
          if (propertiesMetadatasLength < classParamsLength) {
            throw new ConstructorInjectMissTokenError(ClassName);
          }
        }
      }
      // 如果params不存在需要创建符合形参数量的数组
      var newParams = params || _toConsumableArray(Array(classParamsLength));
      return newParams.map(function (paramType, index) {
        // 查找当前index对应的参数有没有使用装饰器
        var propertyMetadatas = propertiesMetadatas[index] || [];
        // 查找装饰器列表中有没有@Inject装饰器的数据
        var injectMeta = propertyMetadatas.find(function (meta) {
          return meta.key === DECORATOR_KEYS.INJECT;
        });
        if (injectMeta && injectMeta.value === Object || !injectMeta && paramType === Object) {
          // 构造函数的参数可以不使用@Inject，但是一定不能是interface
          throw new InjectFailedError(injectMeta, ClassName, index, paramType);
        }
        // 把装饰器列表收集为对象，并且排除掉@Inject
        var options = propertyMetadatas.reduce(function (acc, meta) {
          if (meta.key !== DECORATOR_KEYS.INJECT) {
            acc[meta.key] = meta.value;
          }
          return acc;
        }, {});
        return {
          key: index,
          provide: resolveForwardRef(injectMeta && injectMeta.value) || paramType,
          value: options
        };
      });
    }
    /**
     * 获取注入的实例属性-返回对象
     *
     * @param {*} ClassName
     * @param {*} provider
     * @return {*}
     * @memberof Injector
     */
  }, {
    key: "getInjectProperties",
    value: function getInjectProperties(ClassName, provider) {
      var _this9 = this;
      var metas = this.getInjectPropertiesMetas(ClassName);
      var properties = {};
      metas.forEach(function (meta) {
        var _meta$value;
        var property = _this9.get(meta.provide, _objectSpread(_objectSpread({}, meta.value), {}, {
          provider: provider
        }));
        if (!(property === void 0 && (_meta$value = meta.value) !== null && _meta$value !== void 0 && _meta$value.optional)) {
          properties[meta.key] = property;
        }
      });
      return properties;
    }
    /**
     * 获取注入属性的装饰器数据
     *
     * @param {*} ClassName
     * @return {*}
     * @memberof Injector
     */
  }, {
    key: "getInjectPropertiesMetas",
    value: function getInjectPropertiesMetas(ClassName) {
      // 获取注入属性的metas-类型是Recors<string, Array>
      var propertiesMetadatas = Reflect.getMetadata(DECORATOR_KEYS.SERVICE_INJECTED_PROPS, ClassName) || {};
      var propertiesMetas = [];
      for (var key in propertiesMetadatas) {
        if (has(propertiesMetadatas, key)) {
          // 当前key属性对应的所有的装饰器
          var propertyMetadatas = propertiesMetadatas[key];
          // 当前key属性对应的@Inject装饰器的数据
          var injectMeta = propertyMetadatas.find(function (meta) {
            return meta.key === DECORATOR_KEYS.INJECT;
          });
          if (!injectMeta || injectMeta.value === Object) {
            // 属性一定要手动指定@Inject
            throw new InjectFailedError(injectMeta, ClassName, key);
          }
          var options = propertyMetadatas.reduce(function (acc, meta) {
            if (meta.key !== DECORATOR_KEYS.INJECT) {
              acc[meta.key] = meta.value;
            }
            return acc;
          }, {});
          propertiesMetas.push({
            key: key,
            provide: resolveForwardRef(injectMeta.value),
            value: options
          });
        }
      }
      return propertiesMetas;
    }
    /**
     * 把providers数组转换成map，避免后续的遍历
     *
     * @param {any[]} providers
     * @memberof Injector
     */
  }, {
    key: "addProviders",
    value: function addProviders(providers) {
      var _this10 = this;
      providers.forEach(function (provider) {
        _this10.addProvider(provider);
      });
    }
    /**
     * 添加新的provider
     *
     * @param {*} provider
     * @memberof Injector
     */
  }, {
    key: "addProvider",
    value: function addProvider(provider) {
      if (provider.provide) {
        this.providerMap.set(provider.provide, provider);
      } else {
        this.providerMap.set(provider, {
          provide: provider,
          useClass: provider
        });
      }
    }
    /**
     * 释放当前Injector中的所有服务实例
     *
     * @memberof Injector
     */
  }, {
    key: "dispose",
    value: function dispose() {
      this.providerMap.forEach(function (value) {
        if (value && value.useCacheValue && value.useCacheValue.dispose) {
          try {
            value.useCacheValue.dispose();
          } catch (error) {
            console.error(error);
          }
        }
      });
      this.providerMap = null;
      this.parent = null;
    }
  }]);
  return Injector;
}();
export { CircularDependencyError, ConstructorInjectMissTokenError, DECORATOR_KEYS, Inject, InjectFailedError, Injectable, Injector, Optional, PropertyInjectMissTokenError, ProviderNotValidError, SERVICE_STATUS, Self, Skip, TokenNotFoundError, createDecorator, forwardRef, has, isForwardRef, isInjectableToken, merge, resolveForwardRef };
//# sourceMappingURL=index.esm.js.map
